import { getDefaultDBEntityDocument, } from "utils-library/dist/db-entity-interfaces";
export const getDefaultUser = () => getDefaultDBEntityDocument({
    authUserId: '',
    displayName: '',
    title: '',
    email: '',
    firstName: '',
    lastName: '',
    rights: [],
});
